import { cn } from "@/lib/utils";
import Image from "next/image";

interface LogoProps {
  className?: string;
  wordmarkOnly?: boolean;
  /** Override the wordmark text colour. Defaults to inherit from context (e.g. text-canvas-fg). */
  color?: string;
  /** Optional className applied to the wordmark text (wordmarkOnly mode only). */
  textClassName?: string;
}

const BASE_WORDMARK =
  "inline-flex select-none items-center gap-2 font-[family-name:var(--font-bebas-neue)] text-[15px] font-bold uppercase tracking-[0.22em]";

export function Logo({ className, wordmarkOnly, color, textClassName }: LogoProps) {
  if (wordmarkOnly) {
    return (
      <span
        className={cn(BASE_WORDMARK, className)}
        style={color ? { color } : undefined}
      >
        <Image src="/logos/mark.svg" alt="" aria-hidden="true" width={15} height={15} className="h-[15px] w-auto" />
        <span
          className={textClassName}
                  >
          Strelve
        </span>
      </span>
    );
  }

  return (
    <span className={cn(BASE_WORDMARK, className)}>
      <Image src="/logos/mark.svg" alt="Strelve" aria-hidden="true" width={15} height={15} className="h-[15px] w-auto" />
      <span
        className={textClassName}
              >
        Strelve
      </span>
    </span>
  );
}
